export default __webpack_public_path__ + "static/media/CodeChef_DDU_Chapter_Certificate.d9249f35.pdf";